import React, { Component } from 'react';
import { Grid, Header, Segment, Tab } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { LoadingBar, TableForm } from 'components/Commons';
import moment from 'moment';
import SettlementCommon from 'components/SettlementList/SettlementCommon';

import numeral from 'numeral';

class SettlementMetaInfo extends Component {
  renderDepositTypeText = (metaInfo) => {
    let depositTypeText = `${metaInfo.depositType.value} : ${metaInfo.depositDay}일`;

    if (metaInfo.depositType.codeName === 'DESIGNATED') {
      depositTypeText += `, 휴일시 : ${metaInfo.depositHolidayType.value}`;
    }

    return depositTypeText;
  };

  renderSettlePeriodText = (metaInfo) => {
    let settlePeriodText;

    if (metaInfo.settlePeriodType.codeName === 'ONCE_PER_MONTH') {
      settlePeriodText = `${metaInfo.settleStartDay} ~ ${metaInfo.settleEndDay}`;
    } else if (metaInfo.settlePeriodType.codeName === 'TWICE_PER_MONTH') {
      settlePeriodText = `${metaInfo.settleStartDay}~${metaInfo.settleEndDay}`;
      settlePeriodText += `, ${metaInfo.secondSettleStartDay}~${metaInfo.secondSettleEndDay}`;
    } else if (metaInfo.settlePeriodType.codeName === 'ONCE_PER_WEEK') {
      settlePeriodText = `${metaInfo.settleStartDayOfWeek} ~ ${metaInfo.settleEndDayOfWeek}`;
    }

    return settlePeriodText;
  };

  renderContractTypeText = (metaInfo) => {
    let contractTypeText;

    if (metaInfo.contractType.codeName === 'MEALPOINT' || metaInfo.contractType.codeName === 'MYPOINT') {
      contractTypeText = `${metaInfo.serviceRate}%`;
    } else if (metaInfo.contractType.codeName === 'MINIMUM_GUARANTEE') {
      contractTypeText = `${numeral(metaInfo.minGuaranteeAmt).format('0,0')} ~ `;
      contractTypeText += numeral(metaInfo.maxGuaranteeAmt).format('0,0');
    } else {
      contractTypeText = numeral(metaInfo.fixedAmt).format('0,0');
    }
    return contractTypeText;
  };

  renderContractList = (contractList) => {
    return contractList.map((item) => (
      <Grid.Row key={item.priority}>
        <Grid.Column width={1} />
        <Grid.Column width={3}>{item.contractType.value}</Grid.Column>
        <Grid.Column width={3}>
          {this.renderContractTypeText(item)}
          {item.contractVatFlag ? ' (VAT 별도)' : ' (VAT 포함)'}
        </Grid.Column>
        <Grid.Column width={3}>{item.memo}</Grid.Column>
        <Grid.Column width={6}>
          {item.contractType.codeName === 'UNIQUENESS' && item.tempFlag
            ? `유효일자 : ${moment(item.validYmd).format('YYYY-MM-DD')}`
            : ''}
        </Grid.Column>
      </Grid.Row>
    ));
  };

  renderManagerList = (managerList) => {
    if (!managerList) return null;

    return managerList.map((item) => (
      <Grid.Row key={item.name} style={{ border: 'none' }}>
        <Grid.Column>
          {item.name} ({item.email})
        </Grid.Column>
      </Grid.Row>
    ));
  };

  renderCompanyStoreList = (companyStoreList) => {
    const companyStoreTable = {
      header: {
        main: [
          { data: '제휴식당', textAlign: 'center' },
          { data: '정산방식', textAlign: 'center' },
          { data: '과세유형', textAlign: 'center' }
        ]
      },
      body: {
        message: '식당 정보가 존재하지 않습니다.',
        main: null
      }
    };

    companyStoreTable.body.main = companyStoreList.map((item) => {
      const settleTypeName = item.settleType ? item.settleType.value : '';
      const taxationTypeName = item.taxationType ? item.taxationType.value : '';

      const obj = {
        row: [
          {
            data: item.storeName,
            textAlign: 'center'
          },
          {
            data: settleTypeName,
            textAlign: 'center'
          },
          {
            data: taxationTypeName,
            textAlign: 'center'
          }
        ]
      };
      return obj;
    });

    return <TableForm selectable="true" tabledata={companyStoreTable} />;
  };

  renderMetaInfo = (metaInfo) => {
    const { contractList } = metaInfo;
    const { managerList } = metaInfo;
    const { companyStoreList } = metaInfo;

    const depositTypeText = this.renderDepositTypeText(metaInfo);
    const settlePeriodText = this.renderSettlePeriodText(metaInfo);
    const contractListTable = this.renderContractList(contractList);
    const managerListTable = this.renderManagerList(managerList);
    const companyStoreTable = this.renderCompanyStoreList(companyStoreList);

    return (
      <Tab.Pane style={{ width: 'unset', border: 'none' }}>
        <Grid>
          <Grid.Row style={{ paddingTop: '0px' }}>
            <Grid.Column style={{ paddingLeft: '0px', paddingRight: '0px' }}>
              <Segment>
                <Grid style={{ marginBottom: '20px' }}>
                  <Grid.Row>
                    <Grid.Column>
                      <Header as="h3">기본 정보</Header>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={1} />
                    <Grid.Column width={3}>사업자 등록번호</Grid.Column>
                    <Grid.Column width={12}>{SettlementCommon.bizSerialFormatter(metaInfo.bizSerial)}</Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={1} />
                    <Grid.Column width={3}>회사명</Grid.Column>
                    <Grid.Column width={12}>{metaInfo.companyName}</Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={1} />
                    <Grid.Column width={3}>주소</Grid.Column>
                    <Grid.Column width={12}>{metaInfo.address}</Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={1} />
                    <Grid.Column width={3}>대표명</Grid.Column>
                    <Grid.Column width={12}>{metaInfo.chargeName}</Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={1} />
                    <Grid.Column width={3}>사업자명</Grid.Column>
                    <Grid.Column width={12}>{metaInfo.bizName}</Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={1} />
                    <Grid.Column width={3}>휴대폰 연락처</Grid.Column>
                    <Grid.Column width={12}>{metaInfo.phone}</Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={1} />
                    <Grid.Column width={3}>담당자</Grid.Column>
                    <Grid.Column width={12}>
                      <Grid>{managerListTable}</Grid>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>
              <Segment>
                <Grid style={{ marginBottom: '20px' }}>
                  <Grid.Row>
                    <Grid.Column>
                      <Header as="h3">세금계산서 정보</Header>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={1} />
                    <Grid.Column width={3}>입금은행</Grid.Column>
                    <Grid.Column width={12}>{metaInfo.bankName}</Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={1} />
                    <Grid.Column width={3}>입금자</Grid.Column>
                    <Grid.Column width={12}>{metaInfo.depositor}</Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={1} />
                    <Grid.Column width={3}>식대입금일</Grid.Column>
                    <Grid.Column width={12}>{depositTypeText}</Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={1} />
                    <Grid.Column width={3}>세금계산서 포맷</Grid.Column>
                    <Grid.Column width={12}>{metaInfo.taxFormatType.value}</Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={1} />
                    <Grid.Column width={3}>세금계산서 일자 유형</Grid.Column>
                    <Grid.Column width={12}>{metaInfo.taxInvoiceDate.value}</Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={1} />
                    <Grid.Column width={3}>세금계산서 이메일1</Grid.Column>
                    <Grid.Column width={12}>{metaInfo.taxInvoiceEmail1}</Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={1} />
                    <Grid.Column width={3}>세금계산서 이메일2</Grid.Column>
                    <Grid.Column width={12}>{metaInfo.taxInvoiceEmail2}</Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>
              <Segment>
                <Grid style={{ marginBottom: '20px' }}>
                  <Grid.Row>
                    <Grid.Column>
                      <Header as="h3">정산 정보</Header>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={1} />
                    <Grid.Column width={3}>정산방식</Grid.Column>
                    <Grid.Column width={12}>{metaInfo.settleType.value}</Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={1} />
                    <Grid.Column width={3}>정산주기</Grid.Column>
                    <Grid.Column width={12}>{metaInfo.settlePeriodType.value}</Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={1} />
                    <Grid.Column width={3}>정산범위</Grid.Column>
                    <Grid.Column width={12}>{settlePeriodText}</Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>
              <Segment>
                <Grid style={{ marginBottom: '20px' }}>
                  <Grid.Row>
                    <Grid.Column>
                      <Header as="h3">계약 정보</Header>
                    </Grid.Column>
                  </Grid.Row>
                  {contractListTable}
                </Grid>
              </Segment>
              <Segment>
                <Grid.Row>
                  <Grid.Column>
                    <Header as="h3" textAlign="center">
                      제휴식당 정보
                    </Header>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <div style={{ marginTop: '20px' }}>{companyStoreTable}</div>
                </Grid.Row>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Tab.Pane>
    );
  };

  render() {
    const { metaInfo } = this.props;
    let metaInfoTable;

    if (metaInfo && metaInfo.data) {
      metaInfoTable = this.renderMetaInfo(metaInfo.data);
    }

    let loading = '';
    if (!metaInfo) {
      loading = <LoadingBar />;
    }

    return (
      <div>
        {loading}
        {metaInfoTable}
      </div>
    );
  }
}

SettlementMetaInfo = connect((state) => ({
  metaInfo: state.settlement.settlementMetaInfo
}))(SettlementMetaInfo);

export default SettlementMetaInfo;
